import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromOpusJobs from './opus-jobs.reducer';

export interface OpusJobsState {
  details: fromOpusJobs.OpusJobDetailsState;
}

export const reducers: ActionReducerMap<OpusJobsState> = {
  details: fromOpusJobs.reducer
};

export const getOpusJobsState = createFeatureSelector<OpusJobsState>('job');

export { OpusJobDetailsState } from './opus-jobs.reducer';
